import api from '../helpers';

export default {
  processSos: {
    key: 'processSos',
    query: () => {
      return api.post('/api/crm/sos-process', {
        _throwError: true,
      });
    },
  },
  processHubspot: {
    key: 'processHubspot',
    query: () => {
      return api.post('/api/crm/hubspot-process', {
        _throwError: true,
      });
    },
  },
  convertToSuperCompany: {
    key: 'convertToSuperCompany',
    query: (parent, child) => {
      return api.post('/api/crm/convert-to-super-company', {
        data: {
          parent,
          children: [child],
        },
        _throwError: true,
      });
    },
  },
  hubspotPipelines: {
    key: 'hubspotPipelines',
    query: () => {
      return api.get('/api/crm/hubspot/pipelines', {
        _throwError: true,
      });
    },
  },
  hubspotTickets: {
    key: 'hubspotTickets',
    query: (companyId, includeSubCompanies = true, offset = 0, limit = 50) => {
      return api.get(`/api/companies/${companyId}/hubspot-tickets`, {
        params: {
          includeSubCompanies,
          offset,
          limit,
        },
        _throwError: true,
      });
    },
  },
  hubspotUnmappedTickets: {
    key: 'hubspotUnmappedTickets',
    query: (companyId, offset = 0, limit = 50) => {
      return api.get(`/api/companies/${companyId}/hubspot-tickets`, {
        params: {
          offset,
          limit,
          unmapped: true,
        },
        _throwError: true,
      });
    },
  },
  syncHubspotTickets: {
    key: 'syncHubspotTickets',
    query: (pipelineId) => {
      return api.post(`/api/crm/hubspot/pipelines/${pipelineId}/tickets/sync`, {
        params: {
          fetchAll: true,
        },
        _throwError: true,
      });
    },
  },
  syncHubspotPipeline: {
    key: 'syncHubspotPipeline',
    query: (pipelineId) => {
      return api.post(`/api/crm/hubspot/pipelines/${pipelineId}/sync`, {
        params: {
          refresh: true,
        },
        _throwError: true,
      });
    },
  },
};
